import React from 'react'

type IPageTitle = {
	title: React.ReactNode
}
export const PageTitle = ({
	title
}: IPageTitle) => {

	return (
		<div className="section-title d-sm-flex justify-content-between align-items-center mb-24 text-center">
			<h4 className="text-dark mb-0">{title}</h4>
			{/*TODO: breadcrumbs... */}
			{/*<nav aria-label="breadcrumb">
				<ol className="breadcrumb mb-0 mt-2 mt-sm-0 justify-content-center">
					<li className="breadcrumb-item fs-14"><a className="text-decoration-none" href="index.html">Dashboard</a></li>
					<li className="breadcrumb-item fs-14">Apps</li>
					<li className="breadcrumb-item fs-14 text-primary" aria-current="page">Calendar</li>
				</ol>
			</nav>*/}
		</div>
	)
}